
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'


const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className="d-flex flex-column flex-lg-row flex-column-fluid">
      <div className="d-flex flex-center w-lg-100 p-10">

        <div style={{ background: '#fbfbfb' }} className="card  rounded-3 w-lg-900px">


          <div className="card-body p-2 p-lg-20">
            <Outlet />

          </div></div>

      </div>

    </div>
  )
}

export { AuthLayout }
